export default __webpack_public_path__ + "static/media/google-play-badge.c1a7cc5d.png";